<template>
    <div class="TravelView">
      <v-container fluid>
        <v-row>
          <v-col class="pa-0">
            <BannerTextComponent :image="require('@/assets/banners/banner00.png')" height="40vh" />
          </v-col>
        </v-row>
        <v-row style="background-color: #fafaff;">
          <v-col align-self="center" align="center">
            <div align="center" class="titleSection py-15 my-16">
              Alojamientos
            </div>
            <GiftCardListComponent class="px-md-15 px-5" :items="$store.state.travel.filter(item => item.country === 'CL' && item.category === 'alojamientos')" />
          </v-col>
        </v-row>
        <v-row style="background-color: #fafaff;">
          <v-col align-self="center" align="center">
            <div align="center" class="titleSection py-15 my-16">
              Panoramas
            </div>
            <GiftCardListComponent class="px-md-15 px-5" :items="$store.state.travel.filter(item => item.country === 'CL' && item.category === 'panoramas')" />
          </v-col>
        </v-row>
        <v-row style="background-color: #fafaff;">
          <v-col align-self="center" align="center">
            <div align="center" class="titleSection py-15 my-16">
              Tours
            </div>
            <GiftCardListComponent class="px-md-15 px-5" :items="$store.state.travel.filter(item => item.country === 'CL' && item.category === 'tours')" />
          </v-col>
        </v-row>
        <v-row style="background-color: #fafaff;">
          <v-col align-self="center" align="center">
            <div align="center" class="titleSection py-15 my-16">
              Otros
            </div>
            <GiftCardListComponent class="px-md-15 px-5" :items="$store.state.travel.filter(item => item.country === 'CL' && item.category === 'otros')" />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="px-0">
            <SingleButtonParallaxComponent message="Compra tus puntos Passpoint y canjea tus Beneficios" button="Comprar Puntos" link="/" :background="require('@/assets/backgrounds/dominga.png')" />
          </v-col>
        </v-row>
      </v-container>
    </div>
</template>

<script>
import './_TravelView.scss'
import BannerTextComponent from '@/components/BannerTextComponent/BannerTextComponent.vue'
import GiftCardListComponent from '@/components/GiftCardListComponent/GiftCardListComponent.vue'
import SingleButtonParallaxComponent from '@/components/SingleButtonParallaxComponent/SingleButtonParallaxComponent.vue'

export default {
  name: 'TravelView',
  components: { GiftCardListComponent, SingleButtonParallaxComponent, BannerTextComponent },
  data () {
    return {
      steps: [
        {
          title: 'Paso 1',
          message: 'Selecciona tu ticket en tu App'
        },
        {
          title: 'Paso 2',
          message: 'Escanea el punto de control'
        },
        {
          title: 'Paso 3',
          message: 'Disfruta el evento'
        }
      ]
    }
  }
}
</script>
